import { IPayoutMethodBankDetails, IPayoutMethodUPI, PayoutMethodType } from "../../../../../types/models/payout-transaction.modals.types";
import { usePostHttp } from "../../../http.hook";

export interface IPayoutMethod {
  id: string;
  payoutMethodType: PayoutMethodType;
  bankAccountDetails: IPayoutMethodBankDetails | null;
  upiDetails: IPayoutMethodUPI | null;
  gst: {
    gst: string;
    businessName: string;
    legalName: string | null;
    tradeName: string | null;
  } | null;
  isVerified: boolean;
  name: string;
  submittedName: string;
  user?: { name: string; email: string };
}

export interface IPostPayoutActionResponse {
  payoutMethod: IPayoutMethod;
}

export function useApprovePayoutAdminHttp() {
  return usePostHttp<null, IPostPayoutActionResponse>({
    path: "/admin/kyc/creator/payout/:payoutMethodId/approve",
  });
}
